import React, { useState } from 'react';
import { Card, Spin } from 'antd';
import { CDBIcon } from 'cdbreact';

const MovementsSummary = ({ monthlyTotal, loading }) => {
    const [showDeposits, setShowDeposits] = useState(false);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                width: '100%',
                gap: '50px',
                paddingLeft: '30px',
            }}
        >
            <Card 
                style={{ 
                    width: 500, 
                    background: showDeposits ? '#D9FFD5' : '#9A9A9A', 
                    color: showDeposits ? '#3E3E3E' : '#FFFFFF', 
                    border: showDeposits ? '1px solid #0E9600' : '1px solid #9A9A9A', 
                    position: 'relative', 
                    transition: 'background-color 0.3s, border-color 0.3s', 
                    fontFamily: 'Montserrat, sans-serif' 
                }}
            >
                <div
                    style={{ cursor: 'pointer', position: 'absolute', top: '10px', right: '10px' }}
                    onClick={() => setShowDeposits(!showDeposits)}
                >
                    {showDeposits ? <CDBIcon icon="eye" /> : <CDBIcon icon="eye-slash" />}
                </div>
                <div style={{ marginTop: '10px' }}>
                    <p style={{ textAlign: 'left' }} className="fw-bold h4">
                        {showDeposits ? (
                            loading ? <Spin size="small" /> : `$${parseFloat(monthlyTotal.toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                        ) : '******'}
                    </p>
                </div>
                <p style={{ textAlign: 'left' }} className="fw-bold h5">Mes actual</p>
            </Card>
        </div>
    );
};

export default MovementsSummary;
